import { useMutation } from '@tanstack/react-query';

import { exportCustomerReport } from '../../../common/api/clients/export.api';

export const useCustomerReportDownload = () => {
    return useMutation({ mutationFn: exportCustomerReport });
};
